import axiosInstance from './axiosConfig';

export interface PaymentStatusTransaction {
  transaction_id: string;
  sender_name?: string;
  transaction_amount: number;
  transaction_currency: string;
  status: string;
  transaction_method?: string;
  verified_at?: string;
  method_details?: Record<string, unknown>;
}

export interface PaymentStatusResponse {
  success: boolean;
  transaction?: PaymentStatusTransaction;
  error?: string;
}

/** Poll / reconcile Stripe Checkout session → CWY transaction status. */
export async function getStripePaymentStatus(
  sessionId: string
): Promise<PaymentStatusResponse> {
  const response = await axiosInstance.get<PaymentStatusResponse>(
    `/api/stripe/status/${encodeURIComponent(sessionId)}`
  );
  return response.data;
}
